export default {
  activeVersion: 'v1.0.0',
  baseUrl: 'https://shared.mediahuis.be/fonts/indo',
};
